import { Skeleton } from '@dev-spendesk/grapes';

import { useTranslation } from 'common/hooks/useTranslation';
import { useCompanyId } from 'modules/app/hooks/useCompanyId';
import { TravelPageWrapper } from 'modules/trips/components/TravelPageWrapper/TravelPageWrapper';
import { routeFor, routes } from 'src/core/constants/routes';
import history from 'src/core/history';

export const PropertyDetailsPageSkeleton = () => {
  const { t } = useTranslation('global');
  const companyId = useCompanyId();
  return (
    <TravelPageWrapper
      onBack={() =>
        history.push(
          routeFor(routes.TRAVEL_SEARCH.path, {
            company: companyId,
          }),
        )
      }
      title={t('travel.propertyDetails.header.title')}
    >
      <div className="relative flex min-h-0 flex-1 px-40 pr-0 pb-0">
        <div className="w-[600px] min-w-0 shrink pt-24">
          <Skeleton height="400px" width="100%" className="rounded-12" />
        </div>
        <div className="flex min-h-0 min-w-[500px] flex-1 flex-col gap-24 overflow-auto py-24 pr-24 pl-40">
          <Skeleton height="200px" width="100%" />
          <Skeleton height="80px" width="100%" />
          <Skeleton height="150px" width="100%" />
        </div>
      </div>
    </TravelPageWrapper>
  );
};
